import { Button } from "@mui/material";
import React, { useContext, useState } from "react";
import globalContext from '../../context/context'
import { CssTextField } from "../../utils/CssTextField";
import { useTranslation } from "react-i18next";

function ForgetPassword() {

    const { t } = useTranslation();
    const { resetPassword, setSnack } = useContext(globalContext);

    const [username, setUsername] = useState('');
    const [pass, setPass] = useState('');

    const handleLogin = () => {


        let errors = '';

        if (!username) {
            errors = t("LoginComponent.everyField")
        } 

        if(errors){
            setSnack({
                message: errors,
                severity: 'error',
                open: true
            })
        } else{
            resetPassword(username)
        }

    }



    return (
        <>
            <CssTextField size="small"
                value={username}
                name="username"
                onChange={(e) => setUsername(e.target.value)}
                sx={{ mt: 1 }} fullWidth variant="standard" label={t("LoginComponent.email")} />
            <Button variant="outlined" onClick={handleLogin}>
                Reset password
            </Button>
        </>
    );
}

export default ForgetPassword;
